const section1 = (tl) => {
  tl.add({
    targets: '.js--play-video',
    easing: 'easeInOutSine',
    duration: 1000,
    scale: [1, 1.1],
    easing: 'easeInOutSine',
  });
};

exports.initialiseSection1 = section1;
